import TileHeader from '@/molecules/Tile/components/header/TileHeader';

export type { TileHeaderProps } from './types';

export default TileHeader;
